import { render, staticRenderFns } from "./access-card.vue?vue&type=template&id=38f689c2&scoped=true&"
import script from "./access-card.vue?vue&type=script&lang=ts&"
export * from "./access-card.vue?vue&type=script&lang=ts&"
import style0 from "./access-card.vue?vue&type=style&index=0&id=38f689c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f689c2",
  null
  
)

export default component.exports